<script lang="ts" setup>
import LightArrowIcon from "@/components/icon/LightArrowIcon.vue";
import PicIcon from "@/components/icon/PicIcon.vue";
import { computed, onMounted, ref } from "vue";
import { usePrompts } from "@/stores/prompts";
import { useMateTrait } from "@/stores/mateTrait";
import ThreadsNav from "@/components/mobile/ThreadsNav.vue";
import { useI18n } from "vue-i18n";
import api from "@/modules/api";
import { nextTick } from "vue";
import { showLoadingToast } from "vant";

const props = defineProps({
  show: {
    type: Boolean,
    required: true,
  },
  reqData: {
    type: Object as any,
    required: true,
  },
  enableSelectionLock: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits({
  "update:show": (val: boolean) => undefined,
  saved: () => undefined,
});

// State
const promptStore = usePrompts();
const store = useMateTrait();

const loadingPrompts = ref(false);
const mediaList = ref<any[]>();
const currentMedia = ref<any>(null);
const isGenerating = ref(false);
const imgLoaded = ref(false);

const { t } = useI18n();

const step = ref("people");
// Lifecycle
const trait = useMateTrait();

const show = computed({
  get: () => {
    if (props.show) {
      mediaList.value = undefined;
      currentMedia.value = null;
    }
    return props.show;
  },
  set(val) {
    emit("update:show", val);
  },
});

const onConfirmGenImage = async () => {
  if (isGenerating.value) return;
  try {
    const params = JSON.parse(JSON.stringify(props.reqData));
    if (!mediaList.value) mediaList.value = [];
    if (step.value !== "preview") nextTick(() => (step.value = "preview"));
    isGenerating.value = true;
    imgLoaded.value = false;

    const res = await api.createOneTextImage({
      ...params,
      isRemoveBackground: true,
      from: "image",
    });
    const mediaItem = {
      ...res.item,
      ...params,
      mediaId: res.item.id,
    };
    isGenerating.value = false;
    mediaList.value.push(mediaItem);
    currentMedia.value = mediaItem;
  } finally {
    isGenerating.value = false;
  }
};

const clickSave = async () => {
  // emit("save");
  let {
    name,
    mediaId,
    id,
    mateTraitId: traitId,
    faceExpression,
    pose,
    clothing,
  } = props.reqData;
  if (currentMedia.value) mediaId = currentMedia.value.mediaId;

  const params = { faceExpression, pose, clothing, traitId };
  const toast = showLoadingToast({
    message: t("Message.savingCharacterPortrait"),
    duration: 0,
  });
  try {
    if (id) {
      await store.updatePortrait(id, { ...params, mediaId, name });
    } else {
      await store.createPortrait({
        ...params,
        mediaId,
        name: t("Message.unnamedCharacterPortrait"),
      });
    }
  } catch (e) {}
  toast.close();
  emit("update:show", false);
  emit("saved");
};

const onSwitchImage = (media: any) => {
  currentMedia.value = media;
  const { clothing, faceExpression, pose } = media;
  props.reqData.clothing = clothing;
  props.reqData.faceExpression = faceExpression;
  props.reqData.pose = pose;
};

onMounted(() => {
  Promise.all([
    promptStore.getOrFetchImgPrompts(),
    trait.getOrFetchTraitList(),
  ]);
});
</script>
<template>
  <VanPopup v-model:show="show" class="h-[80%]" position="bottom">
    <div class="h-full grid grid-rows-[auto_1fr_auto]">
      <!-- 顶部导航 -->
      <threads-nav :show-center="false">
        <template #left>
          <button class="btn btn-ghost" @click="emit('update:show', false)">
            <light-arrow-icon />
          </button>
        </template>
        <template #right>
          <button
            v-if="reqData.id || currentMedia"
            :disabled="isGenerating"
            class="btn btn-primary btn-outline btn-sm rounded"
            @click="clickSave"
          >
            {{ t(`Buttons.save`) }}
          </button>
          <button
            class="btn btn-primary btn-sm rounded"
            @click="onConfirmGenImage"
          >
            <i class="iconify mingcute--pic-line" />
            {{ $t("Buttons.generate") }}
          </button>
        </template>
      </threads-nav>
      <div
        v-if="!loadingPrompts"
        class="w-full h-full flex justify-center overflow-hidden"
      >
        <VanTabs v-model:active="step" class="w-full h-full overflow-auto">
          <VanTab :title="$t('trait.tab.descriptors')" name="people">
            <ImageTabsTrait
              :enableSelectionLock="enableSelectionLock"
              :req-data="reqData"
            />
          </VanTab>
          <VanTab
            v-if="mediaList"
            :title="$t('trait.generatePreview')"
            name="preview"
          >
            <TraitTabsMediaList
              v-model:img-loaded="imgLoaded"
              :current-media="currentMedia"
              :is-generating="isGenerating"
              :media-list="mediaList"
              @update:current-media="onSwitchImage"
            />
          </VanTab>
        </VanTabs>
      </div>
      <div
        v-if="loadingPrompts"
        class="h-full flex flex-grow items-center justify-center"
      >
        <div class="loading"></div>
      </div>
    </div>
  </VanPopup>
</template>
